<section class="detalle">
  <!-- Dominios -->
  <app-scores-section
    class="block"
    kind="domain"
    [domainLabel]="detailContent?.domainLabel ?? ''"
    [levelLabel]="detailContent?.levelLabel ?? ''"
    [peopleLabel]="detailContent?.peopleLabel ?? ''"
    [title]="detailContent?.domainLabel ?? ''">
  </app-scores-section>
</section>
